<template>
    <!-- <v-app-bar dense color="primary" dark height="30" flat>
        <v-toolbar-title class="body-2">{{title}}</v-toolbar-title>
        <slot></slot>
    </v-app-bar> -->
    <v-app-bar dense :color="color" dark flat :height="height()" @click="$emit('click')">
        <v-toolbar-title :class="font" ><v-icon v-if="icon!=''">{{icon}}</v-icon>{{title}}</v-toolbar-title>
        <slot></slot>
    </v-app-bar>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: "title"
            },
            dense: {
                type: Boolean,
                default: false
            },
            font: {
                type: String,
                default: "body-1 font-weight-bold"
            },
            icon: {
                type: String,
                default: ""
            },
            color: {
                type: String,
                default: "primary"
            }
        },
        methods: {
            height: function () {
                if (this.dense) {
                    return 30
                } else {
                    return null
                }
            }
        }
    }
</script>
